import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Building2, Users, MapPin, ClipboardList } from "lucide-react";
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { StatCard, PageLoading } from "@/components/shared";
import api from "@/lib/api";

const COLORS = { VALID: "#059669", COMPLIANT: "#059669", EXPIRING_SOON: "#D97706", REVIEW_REQUIRED: "#D97706", MISSING: "#DC2626", EXPIRED: "#DC2626", NOT_COVERING_ASSIGNMENT: "#DC2626" };
const PALETTE = ["#06B6D4", "#0D9488", "#0A192F", "#D97706", "#DC2626", "#64748B"];

export default function SubOverview() {
  const { t } = useTranslation();
  const [d, setD] = useState(null);
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/subcon/overview").then((r) => setD(r.data)).catch(() => setD({})); api.get("/subcon/statistics").then((r) => setS(r.data)).catch(() => setS(null)); }, []);
  if (!d) return <PageLoading />;
  return (
    <div data-testid="sub-overview">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <StatCard label={t("sub.ovActiveSubs")} value={d.active_subcontractors || 0} icon={Building2} accent="navy" testid="ov-active-subs" />
        <StatCard label={t("sub.ovWorkers")} value={d.workers || 0} icon={Users} accent="cyan" testid="ov-workers" />
        <StatCard label={t("sub.ovActiveSites")} value={d.active_sites || 0} icon={MapPin} accent="navy" testid="ov-active-sites" />
        <StatCard label={t("sub.ovSubs")} value={d.subcontractors || 0} icon={Building2} testid="ov-subs" />
        <StatCard label={t("sub.ovSites")} value={d.sites || 0} icon={MapPin} testid="ov-sites" />
        <StatCard label={t("sub.ovAssignments")} value={d.active_assignments || 0} icon={ClipboardList} accent="cyan" testid="ov-assignments" />
      </div>
      {s && (
        <div className="mt-6 grid gap-6 lg:grid-cols-2" data-testid="sub-statistics">
          <div className="card-soft p-6">
            <h3 className="mb-4 font-heading font-bold text-navy">{t("sub.statA1")}</h3>
            <ResponsiveContainer width="100%" height={220}>
              <PieChart><Pie data={s.a1} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label>{s.a1.map((e, i) => <Cell key={i} fill={COLORS[e.name] || PALETTE[i % PALETTE.length]} />)}</Pie><Tooltip /></PieChart>
            </ResponsiveContainer>
          </div>
          <div className="card-soft p-6">
            <h3 className="mb-4 font-heading font-bold text-navy">{t("sub.statExpiring")}</h3>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={s.expiring}><CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" /><XAxis dataKey="name" fontSize={12} stroke="#94a3b8" /><YAxis allowDecimals={false} fontSize={12} stroke="#94a3b8" /><Tooltip /><Bar dataKey="value" fill="#06B6D4" radius={[4, 4, 0, 0]} /></BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
    </div>
  );
}
